import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import App from '../App/App'

import Home from '../home/Home';
import ShopStore from '../shop/app/ShopStore';
import AdminDashboard from '../admin/app/AdminDashboard';
import { ProfileProvider } from '../contexts/ProfileContext';
import ProfilePage from '../pages/ProfilePage';

import Province from '../content/province/Province';

import Tipologia from '../content/tipologie/Tipologia';
import IntroTipologia from '../content/tipologie/IntroTipologia';
import VinoBianco from '../content/tipologie/VinoBianco';
import VinoCerasuolo from '../content/tipologie/VinoCerasuolo';
import VinoRosso from '../content/tipologie/VinoRosso';

import Vitigno from '../content/vitigni/Vitigno';
import VitignoAutoctono from '../content/vitigni/VitignoAutoctono';
import VitignoImportato from '../content/vitigni/VitignoImportato';
import TecnicaColtiva from '../content/vitigni/TecnicaColtiva';
import InovazioneViti from '../content/vitigni/InovazioneViti';

import SimulatorSommelier from '../content/spareTime/SimulatorSommelier';
import QuizAbruzzoVini from '../content/spareTime/QuizAbruzzoVini';
import SagreAbruzzese from '../content/spareTime/SagreAbruzzese';

import AbruzzoVini from '../content/AbruzzoWine/AbruzzoVini';
import StoriaDelVino from '../content/AbruzzoWine/StoriaDelVino';
import ClassDenom from '../content/AbruzzoWine/ClassDenom';
import GammaVini from '../content/AbruzzoWine/GammaVini';
import EventoEnogastro from '../content/AbruzzoWine/EventoEnogastro';

import ScegliereVini from '../content/chooseWine/ScegliereVini';
import IntroScelta from '../content/chooseWine/IntroScelta'; 
import Etichette from '../content/chooseWine/Etichette';
import Abbinamento from '../content/chooseWine/Abbinamento';
import ViniRegalo from '../content/chooseWine/ViniRegalo';

import DegustazioneVini from '../content/tasteWine/DegustazioneVini';
import Servicio from '../content/tasteWine/Servicio';
import EsameV from '../content/tasteWine/EsameV';
import EsameO from '../content/tasteWine/EsameO';
import EsameGO from '../content/tasteWine/EsameGO'; 

import OnlineStore from '../shop/home/OnlineStore';

import Vini from '../shop/content/Vini/Vini';
import ViniRossi from '../shop/content/Vini/ViniRossi';
import ViniBianchi from '../shop/content/Vini/ViniBianchi';
import ViniRosati from '../shop/content/Vini//ViniRosati';
import SchedaVini from '../shop/content/Vini/SchedaTecnicaVini';

import Spumanti from '../shop/content/spumanti/Spumanti';
import Birre from '../shop/content/birre/Birre';
import Distillati from '../shop/content/distillati/Distillati';
import CantineFrigo from '../shop/content/cantine-frigo/CantineFrigo';
import Accessori from '../shop/content/accessori/Accessori';
import CestiRegalo from '../shop/content/Cesti/CestiRegalo';
import OfferteSpeciali from '../shop/content/offerte/OfferteSpeciali';
import ProdottiRegionale from '../shop/content/regionali/ProdottiRegionali';
import ZonaArtigianale from '../shop/content/artigianale/ZonaArtigianale';

import HomeDashboard from '../admin/home/HomeDashboard'; 
import AdminRoute from '../admin/components/AdminRoute';
import AdminOrders from '../admin/content/AdminOrders';
import AdminUsers from '../admin/content/AdminUsers';
import AdminStats from '../admin/content/AdminStats';
import AdminCoupons from '../admin/content/AdminCoupons';
import AdminShipping from '../admin/content/AdminShipping';
import AdminNewsletter from '../admin/content/AdminNewsletter';
import AdminSuppliers from '../admin/content/AdminSuppliers';  

/*import ServizioDiPagamento from '../components/services/PaiementServices';
 import AntiprimaCarrello from '../cart/PreviewCart' */
import Carrello from '../cart/Cart';
//import CheckOut from '../features/CheckOut';
import OrdineDiretto from '../features/OrdineDiretto';
import OrdinePagamento from '../features/OrdinePagamento';
import OrdineConfermato from '../features/OrdineConfermato';

function Router() {
    return (
        <BrowserRouter future={{ v7_startTransition: true,}}>
            <Routes>
                <Route exact path='/' element={<App />} >

                    <Route index element={<Home />} />
                    <Route path="/profile" element={  <ProfileProvider><ProfilePage /></ProfileProvider>} />
                    <Route path="/provincedellabruzzo" element={<Province />} /> 

                    <Route path="tipologiainabruzzo" element={<Tipologia />} />
                    <Route path="tipologiainabruzzo/introduzionesullatipologiadeivini" element={<IntroTipologia />} />
                    <Route path="tipologiainabruzzo/vinificazioneinrosso" element={<VinoRosso/>} />
                    <Route path="tipologiainabruzzo/vinificazioneinbianco" element={<VinoBianco />} />
                    <Route path="tipologiainabruzzo/vinificazionecerasuolo" element={<VinoCerasuolo />} />

                    <Route path="vitignoinabruzzo" element={<Vitigno />} />
                    <Route path="vitignoinabruzzo/vitigniautoctoni" element={<VitignoAutoctono />} />
                    <Route path="vitignoinabruzzo/vitigniimportati" element={<VitignoImportato/>} />
                    <Route path="vitignoinabruzzo/tecnicadicoltivazione" element={<TecnicaColtiva />} />
                    <Route path="vitignoinabruzzo/inivazioneinviticoltura" element={<InovazioneViti />} />

                    {/* Section Admin avec son propre layout et Outlet */}
                    <Route path="admin/*" element={<AdminRoute><AdminDashboard /></AdminRoute>}>
                        <Route index element={<HomeDashboard />} />
                        <Route path="orders" element={<AdminOrders />} />
                        <Route path="users" element={<AdminUsers />} />
                        <Route path="stats" element={<AdminStats />} />
                        <Route path="coupons" element={<AdminCoupons />} />
                        <Route path="shipping" element={<AdminShipping />} /> 
                        <Route path="newsletter" element={<AdminNewsletter />} />
                        <Route path="suppliers" element={<AdminSuppliers />} /> 
                    </Route> 

                    {/* Section BOUTIQUE avec son propre layout et Outlet */}
                    <Route exact path="negozioonline" element={<ShopStore />}>
                        <Route index element={<OnlineStore />} />
                        <Route path="/negozioonline/vini" element={<Vini />} />
                        <Route path="/negozioonline/vini/vinirossi" element={<ViniRossi />} />
                        <Route path="/negozioonline/vini/vinibianchi" element={<ViniBianchi />} />
                        <Route path="/negozioonline/vini/vinirosati" element={<ViniRosati />} />  
                        <Route path="/negozioonline/vini/vinirossi/schedadelvino/:id" element={<SchedaVini/>} />
                        {/*<Route path="negozioonline/vini" element={<ViniBianchi />} />
                        <Route path="negozioonline/cerasuoli" element={<ViniRosati />} />
                        <Route path="negozioonline/vinidolci" element={<ViniDolci />} />
                        <Route path="negozioonline/vinidadessert" element={<ViniDessert />} />
                        <Route path="negozioonline/vinibiologici" element={<ViniBio />} />
                        <Route path="negozioonline/vininaturali" element={<ViniNaturale />} />
                        <Route path="negozioonline/viniperannata" element={<ViniAnnata />} /> */}

                        <Route path="/negozioonline/spumanti" element={<Spumanti />} />
                        {/* <Route path="negozioonline/spumantimetodoclassico" element={<Spumanticlassici />} />
                        <Route path="negozioonline/spumantimetodocharmat" element={<SpumantiCharmat />} />
                        <Route path="negozioonline/spumantiaromatici" element={<SpumantiAromatici />} />*/}


                        <Route path="/negozioonline/birre" element={<Birre />} />
                        {/* <Route path="negozioonline/Birre" element={<BirreArtigianle />} />
                        <Route path="negozioonline/birre" element={<BirreLimite />} />
                        <Route path="negozioonline/birre" element={<KitHomeBrewing />} />*/}
                        
                        <Route path="/negozioonline/distillati" element={<Distillati />} />
                        <Route path="/negozioonline/cantinette" element={<CantineFrigo />} />
                        <Route path="/negozioonline/ustensilieaccessori" element={<Accessori />} />
                        <Route path="/negozioonline/cestiregalo" element={<CestiRegalo />} />
                        <Route path="/negozioonline/offertespeciali" element={<OfferteSpeciali />} />
                        <Route path="/negozioonline/prodottiregionale" element={<ProdottiRegionale />} />
                        <Route path="/negozioonline/zonaartigianale" element={<ZonaArtigianale />} />

                        {/* Section Cart avec attaché à ce layout et Outlet */}
                        <Route path="/negozioonline/carrello" element={<Carrello />}/>
                        <Route path="/negozioonline/checkout/ordinidiretti" element={<OrdineDiretto />} />
                        <Route path="/negozioonline/checkout/ordinepagamento" element={<OrdinePagamento />} />
                        <Route path="/negozioonline/checkout/ordine-confermato" element={<OrdineConfermato />} />
                        {/* <Route path="carrellodellespese/:idWine" element={<AntiprimaCarrello />}/>
                        <Route path="carrellodellespese/serviziodipagamentodelcarrello/:idPs" element={<ServizioDiPagamento />}/>*/}
                        
                    </Route> 

                    <Route path="ilmondodeiviniabruzzese" element={<AbruzzoVini />} />
                    <Route path="ilmondodeiviniabruzzese/storiadelvino" element={<StoriaDelVino />} />
                    <Route path="ilmondodeiviniabruzzese/classificaedenominazionedelvino" element={<ClassDenom />} />
                    <Route path="ilmondodeiviniabruzzese/gammadeivini" element={<GammaVini />} />
                    <Route path="ilmondodeiviniabruzzese/eventiEnogastronomoci" element={<EventoEnogastro />} />

                    <Route path="sceglierebeneivini" element={<ScegliereVini />} />
                    <Route path="sceglierebeneivini/introduzionesullascelta" element={<IntroScelta />} />
                    <Route path="sceglierebeneivini/etichettebotigliedivino" element={<Etichette />} />
                    <Route path="sceglierebeneivini/abbinamentodeivini" element={<Abbinamento />} />
                    <Route path="sceglierebeneivini/vinidaregalo" element={<ViniRegalo />} />

                    <Route path="degustazionedeivini" element={<DegustazioneVini />} />
                    <Route path="degustazionedeivini/ilserviciodelvino" element={<Servicio />} />
                    <Route path="degustazionedeivini/esamevisivodelvino" element={<EsameV />} />
                    <Route path="degustazionedeivini/esameolfativodelvino" element={<EsameO />} />
                    <Route path="degustazionedeivini/esamegustoolfativodelvino" element={<EsameGO />} />
                    
                    <Route path="enoquizabruzzo" element={<QuizAbruzzoVini />} />
                    <Route path="simulatoresommelier" element={<SimulatorSommelier />} /> 
                    <Route path="sagredellabruzzo" element={<SagreAbruzzese />} />

                    {<Route path="*" element={<Navigate replace to="/" />} />}
                </Route>
            </Routes>    
        </BrowserRouter>
    )
}
export default Router;
